import React, { useEffect } from 'react'

import { ScreenSpin } from 'admin/lib/ScreenSpin'

import { msal } from 'admin/lib/Api'
import { OuterContainer } from 'admin/lib/Layouts'

export function SignOut() {
  useEffect(() => {
    msal.logoutRedirect()
  }, [])

  return (
    <OuterContainer>
      <ScreenSpin />
    </OuterContainer>
  )
}
